import React from 'react';
import type { MetricInput } from './types';
import { metricModule } from './registry';
import { deviceMetricViews } from './views';

export default function DeviceMetricIcon({ metric }: { metric: MetricInput }) {
  const Icon = deviceMetricViews[metricModule(metric).id].Icon;
  return <Icon metric={metric} />;
}
